import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=e9f97768&scoped=true&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"
import style0 from "./Screen.vue?vue&type=style&index=0&id=e9f97768&lang=scss&scoped=true&"
import style1 from "./Screen.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Screen.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f97768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e9f97768', component.options)
    } else {
      api.reload('e9f97768', component.options)
    }
    module.hot.accept("./Screen.vue?vue&type=template&id=e9f97768&scoped=true&", function () {
      api.rerender('e9f97768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/Screen.vue"
export default component.exports